import { resolveCDNDir, getCDNContent } from '@gjensidige/se-content-helpers';

let texts;

export const fetchTexts = async (): Promise<void> => {
    try {
        const baseUrl: string =  resolveCDNDir()
        const textUrl: string = `${baseUrl}texts/app-webshop-se-legacy.json`;
        texts = await getCDNContent(textUrl);
    } catch (error) {
        texts = null;
    }
};

export const fetchTextsLocally = () => {
    texts = require('../../../test/mock-data/getTexts.json');
};

export const getText = (key: string): string => {
    return texts[key];
};
